import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "min", "max", "step", "overLimitColor", "keyboard", "formatter", "prefixCls"];
import React, { useState, useMemo } from 'react';
import Input from './';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      className,
      min,
      max,
      step,
      overLimitColor,
      keyboard = false,
      prefixCls = 'w-input-number'
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var value = useMemo(() => {
    var _ref;
    return Number.parseFloat((_ref = props.value || 0) == null ? void 0 : _ref.toString());
  }, [props.value]);
  var [isOverLimit, isOverLimitSet] = useState(overLimitComp(value));
  function overLimitComp(value) {
    if (typeof min === 'number' && value < min) return true;
    if (typeof max === 'number' && value > max) return true;
    return false;
  }
  var onChange = v => {
    var isOverLimit = overLimitComp(Number.parseFloat(v.target.value));
    isOverLimitSet(isOverLimit);
    props.onChange == null || props.onChange(v);
  };
  var overLimitProps = useMemo(() => {
    if (!overLimitColor) return {
      min,
      max
    };
  }, []);
  var cls = [prefixCls, className].filter(Boolean).join(' ').trim();
  var inputStyle = useMemo(() => isOverLimit ? {
    color: overLimitColor == null ? void 0 : overLimitColor.toString()
  } : undefined, [isOverLimit]);
  return /*#__PURE__*/_jsx(Input, _extends({}, otherProps, {
    className: cls,
    type: "number",
    inputStyle: inputStyle,
    onChange: onChange,
    step: step
  }, overLimitProps));
});